import React from 'react';
import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { IDS } from '../constants/ids';
import { POPOVER_MENU_ITEMS } from '../constants';

// TODO use constants for object keys
// TODO use common localisation for menu items
const MENU_OPTIONS = {
  editPost: {
    id: IDS.MENU.EDIT_POST,
    text: { id: 'community.postMenu.editPost' },
    icon: 'edit',
  },
  removePost: {
    id: IDS.MENU.REMOVE_POST,
    text: { id: 'community.postMenu.deletePost' },
    icon: 'remove',
  },
  editComment: {
    id: IDS.MENU.EDIT_COMMENT,
    text: { id: 'community.commentMenu.editComment' },
    icon: 'edit',
    iconSize: '16px',
    iconStyle: { top: '3px', width: '16px', height: '16px' },
  },
  removeComment: {
    id: IDS.MENU.REMOVE_COMMENT,
    text: { id: 'community.commentMenu.deleteComment' },
    icon: 'remove',
    iconSize: '16px',
    iconStyle: { top: '3px', width: '16px', height: '16px' },
  },
  sendMessage: {
    id: IDS.MENU.SEND_MESSAGE,
    text: { id: 'chat.actions.sendMessage' },
    icon: 'comment',
  },
  report: {
    id: IDS.MENU.REPORT,
    text: { id: 'community.menu.report' },
    icon: 'report',
  },
  inviteToCommunity: {
    id: IDS.MENU.INVITE_TO_COMMUNITY,
    text: { id: 'community.menu.invitePeople' },
    icon: 'report',
  },
  shareLink: {
    id: IDS.MENU.SHARE_LINK,
    text: { id: 'community.menu.shareLink' },
    icon: 'attachment',
    iconSize: 16,
    iconStyle: { top: 3 },
  },
  leaveCommunity: {
    id: IDS.MENU.LEAVE_COMMUNITY,
    text: { id: 'community.menu.leaveCommunity' },
    icon: 'leave',
    iconSize: 16,
  },
  [POPOVER_MENU_ITEMS.REMOVE_FROM_COMMUNITY]: {
    id: IDS.MENU.REMOVE_FROM_COMMUNITY,
    text: { id: 'community.menu.removeMember' },
    icon: 'remove-from-community',
  },
  [POPOVER_MENU_ITEMS.REMOVE_MEMBER]: {
    id: IDS.MENU.REMOVE_MEMBER,
    text: { id: 'common.removeMember' },
    icon: 'leave',
  },
  editCommunity: {
    id: IDS.MENU.EDIT_COMMUNITY,
    text: { id: 'community.menu.editCommunity' },
    icon: 'edit',
  },
  [POPOVER_MENU_ITEMS.CHANGE_ROLE]: {
    id: IDS.MENU.CHANGE_ROLE,
    text: { id: 'common.changeRole' },
    icon: 'change',
  },
  [POPOVER_MENU_ITEMS.UNASSIGN]: {
    id: IDS.MENU.UNASSIGN,
    text: { id: 'common.unassign' },
    icon: 'unassign',
  },
  [POPOVER_MENU_ITEMS.CANCEL_PENDING_INVITATION]: {
    text: { id: 'circles.invites.cancelInvite' },
    icon: 'log-out',
  },
  [POPOVER_MENU_ITEMS.INVITE_PATIENT]: {
    text: { id: 'community.menu.invite' },
    icon: 'add-member',
    iconSize: 24,
  },
  [POPOVER_MENU_ITEMS.REINVITE_PATIENT]: {
    text: { id: 'dialog.common.reinvite' },
    icon: 'add-member',
    iconSize: 24,
  },
};

const withPopoverMenu = BaseComponent => ({
  intl: { formatMessage },
  ...props
}) => {
  const getMenuItems = options => {
    const menu = [];

    Object.keys(options).forEach(key => {
      const option = MENU_OPTIONS[key];
      const item = options[key];

      if (option && item) {
        menu.push({
          ...option,
          text: formatMessage(option.text),
          onClick: item,
        });
      }
    });

    return menu;
  };

  return <BaseComponent {...props} getMenuItems={getMenuItems} />;
};

export default compose(
  injectIntl,
  withPopoverMenu,
);



// WEBPACK FOOTER //
// ./src/hocs/withPopoverMenu.jsx